import { render, staticRenderFns } from "./ForumChatThreadCardHeaderAvatar.vue?vue&type=template&id=9bea11fa&scoped=true"
import script from "./ForumChatThreadCardHeaderAvatar.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCardHeaderAvatar.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCardHeaderAvatar.vue?vue&type=style&index=0&id=9bea11fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bea11fa",
  null
  
)

export default component.exports